import axios from './HTTP'

export default {
  getAll (callback) {
    axios
      .get('/api/employee_color_categories.json')
      .then(response => ( callback(response.data) ))
  },
}
